var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconMusic32(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.725 15.039l7-2a.999.999 0 011.274.96v8c0 1.106-1.119 2-2.5 2-1.38 0-2.5-.894-2.5-2 0-1.103 1.12-2 2.5-2 .172 0 .338.016.5.042v-4.715l-5 1.429V23c0 1.105-1.119 2-2.5 2-1.38 0-2.5-.895-2.5-2 0-1.104 1.12-2 2.5-2 .172 0 .338.015.5.04V16a1 1 0 01.726-.961z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 28.75A2.75 2.75 0 016.25 26V6A2.75 2.75 0 019 3.25h9.998a.75.75 0 01.53.22l6.002 5.998c.141.14.22.331.22.53V26A2.75 2.75 0 0123 28.75H9zM7.75 26c0 .69.56 1.25 1.25 1.25h14c.69 0 1.25-.56 1.25-1.25V11H20a2 2 0 01-2-2V4.75H9c-.69 0-1.25.56-1.25 1.25v20z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMusic32);
export default __webpack_public_path__ + "static/media/icon-music-32.20e4d0e5.svg";
export { ForwardRef as ReactComponent };